export const STATES_TYPES = {
  BOOLEAN: 'Boolean',
  OBJECT: 'Object',
  NUMBER: 'Number',
  STRING: 'String',
  DATE_TIME: 'Date/Time',
}

export const STATES_HEADERS = {
  STATE: 'state',
  VALUE: 'value',
  TYPE: 'type',
}
